import { render, staticRenderFns } from "./Form4.vue?vue&type=template&id=6f19e8cc"
import script from "./Form4.vue?vue&type=script&lang=js"
export * from "./Form4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports